import { render } from "./Profiel.vue?vue&type=template&id=45fa78d3"
import script from "./Profiel.vue?vue&type=script&lang=js"
export * from "./Profiel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__